import { React } from 'react';
import showdown from 'showdown';
import parse from 'html-react-parser';

/**
 * Add/Delete Tags at Contexture for a document
 * @param {string} text - String that will have markdown converted and html rendered
 * @public
 */
const MitreText = ({ text, className }) => {
  const converter = new showdown.Converter();
  converter.setOption('openLinksInNewWindow', true);
  const body = parse(converter.makeHtml(text));
  return <span className={`${className} mitre-text`}>{body}</span>;
};
export default MitreText;
